import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'

Vue.use(Router)

export default new Router({
    routes: [
        {   //首页
            path: '/',
            name: 'home',
            component: Home
        },{     //产品服务
            path: '/software',
            name: 'software',
            component: () => import('./views/server/SoftWare.vue')
        },{
            path: '/app',
            name: 'app',
            // route level code-splitting
            // this generates a separate chunk (about.[hash].js) for this route
            // which is lazy-loaded when the route is visited.
            component: () => import(/* webpackChunkName: "about" */ './views/server/App.vue')
        },{
            path: '/service',
            name: 'service',
            component: () => import('./views/server/Service.vue')
        },{
            path: '/cloud',
            name: 'cloud',
            component: () => import('./views/server/Cloud.vue')
        },{
            path: '/maintenance',
            name: 'maintenance',
            component: () => import('./views/server/Maintenance.vue')
        },{
            path: '/supply',
            name: 'supply',
            component: () => import('./views/server/Supply.vue')
        },{     //文档资料
            path: '/document',
            name: 'document',
            component: () => import('./views/Document.vue'),
            meta:{
                auth:true
            }
        },{     //新闻资讯
            path: '/news',
            name: 'news',
            component: () => import('./views/News.vue')
        },{     //关于我们
            path: '/qyj',
            name: 'qyj',
            component: () => import('./views/about/QYJ.vue')
        },{
            path: '/ja',
            name: 'ja',
            component: () => import('./views/about/JA.vue')
        },{
            path: '/cna', //彩超联盟
            name: 'cna',
            component: () => import('./views/about/Cna.vue')
        },{
            path: '/adv',
            name: 'adv',
            component: () => import('./views/about/OurAdv.vue')
        },{     //联系我们
            path: '/join',
            name: 'join',
            component: () => import('./views/contact/Join.vue')
        },{
            path: '/repairs',
            name: 'repairs',
            component: () => import('./views/contact/Repairs.vue')
        },{
            path: '/teamwork',
            name: 'teamwork',
            component: () => import('./views/contact/Teamwork.vue')
        },{
            path: '/video',
            name: 'video',
            component: () => import('./views/video.vue')
        },{
            path: '/login',
            name: 'login',
            component: () => import('./views/login.vue')
        },{
            path: '/article1',
            name: 'article1',
            component: () => import('./views/list/article1.vue')
        },{
            path: '/article2',
            name: 'article2',
            component: () => import('./views/list/article2.vue')
        },{
            path: '/article3',
            name: 'article3',
            component: () => import('./views/list/article3.vue')
        },{
            path: '/article4',
            name: 'article4',
            component: () => import('./views/list/article4.vue')
        }
    ],
    // linkExactActiveClass:'is-active'

})
